import * as React from "react";
import {objectMerge} from "../lib/tools";
import {FormInput, ValidateForm} from "../components/common/formValidation";
import {Button} from "../components/common/common";
import {reduxWrapper} from "../globalState";


class DevToolRender extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.onPress = ({tableName}) => {
			props.apiCall("GET", `/admin/db/table/${tableName}/columns`, data => {
				this.setState({columns: data.map(x => ({...x, value: ""}))});
			})
		};
		
		this.onEdit = (index, val) => {
			this.setState(prev => ({columns: prev.columns.map((x, i) => index === i ? objectMerge(x, {value: val}) : x)}))
		};
		
		this.onFormat = () => {
			let props = [];
			let relations = [];
			
			this.state.columns.forEach(x => {
				if (x.value) {
					props.push(`/** @var ${x.type} $${x.value} */\npublic $${x.value};`);
					relations.push(`"${x.name}" => "${x.value}"`);
				}
			});
			
			this.setState({output: props.join("\n") + "\n\n" + relations.join(",\n")})
		}
	}
	
	
	state = {
		columns: [],
		output: ""
	};
	
	render() {
		return (
			<div id="devTool">
				<ValidateForm onSubmit={this.onPress}>
					<FormInput name="tableName" req/>
					<Button submit>Load</Button>
				</ValidateForm>
				{this.state.columns.map((x, i) => <TableColumn {...x} key={i} onChange={val => this.onEdit(i, val)}/>)}
				<Button onClick={this.onFormat}>Format</Button>
				<pre>
					{this.state.output}
				</pre>
			</div>
		);
	}
}

const DevTool = reduxWrapper("getApiCall")(DevToolRender);

const TableColumn = ({name, type, value, onChange}) => (
	<div className="tableColumn">
		<span>{name}</span>
		<span>{type}</span>
		<FormInput value={value} onChange={val => onChange(val)}/>
	</div>
);


export default DevTool;


// WEBPACK FOOTER //
// ./src/admin/devTool.js